import { Link } from "react-router-dom";
import { useLanguage } from "@/i18n/LanguageContext";

const NotFound = () => {
  const { t } = useLanguage();
  return (
    <div data-testid="not-found-page" className="min-h-[70vh] flex flex-col items-center justify-center px-5 text-center grid-bg">
      <p className="text-7xl font-extrabold font-heading text-gradient mb-6">404</p>
      <h1 className="text-2xl font-bold font-heading text-white mb-3">{t("notFound.title")}</h1>
      <p className="text-sm text-slate-400 mb-8">{t("notFound.sub")}</p>
      <Link to="/" data-testid="not-found-home" className="rounded-full bg-indigo-500 hover:bg-indigo-400 text-white font-semibold px-7 py-3 text-sm transition-colors">
        {t("notFound.back")}
      </Link>
    </div>
  );
};

export default NotFound;
